module.exports = __webpack_public_path__ + "static/img/1_2_3.23cc48f6.png";